<template>
    <div>
        <card-header title="Reflection" :subheader="user.first_name + ' ' + user.last_name" icon="fa-file-alt"></card-header>

        <card-toolbar>
            <template v-slot:right>
                <button><i class="far fa-print" v-b-tooltip.hover title="Print"></i></button>
                <button class="icon-only btn-warning" v-b-tooltip.hover title="Delete"><i class="far fa-trash-alt"></i></button>
            </template>
        </card-toolbar>

        <card-body subheader toolbar>
            <card-subheader title="Reflection" icon="fa-user-edit"/>

            <user-reflection/>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../components/common/CardHeader";
    import CardBody from "../../components/common/CardBody";
    import CardToolbar from "../../components/common/CardToolbar";
    import CardSubheader from "../../components/common/CardSubheader";
    import UserReflection from "../../components/UserReflection";

    export default {
        components: { UserReflection, CardSubheader, CardToolbar, CardBody, CardHeader},
        props: ['props', 'child'],
        methods: {
            loadUser: function () {
                console.log('ud: load user id ' + this.props.userId);
            },
            isActive: function (component) {
                return (this.child && this.child.definition && this.child.definition.component === component);
            },
            openCard: function (card, props) {
                this.$emit('open', {card: card, props: props});
            }
        },
        data() {
            return {
                user: {
                    id: 249,
                    first_name: 'Scott',
                    last_name: 'Lamont',
                    names: [ 'MS', 'Apple', 'Google' ],
                    values: [
                        [ 10, 5, 5, 5 ],
                        [ 40, 10, 10, 10 ],
                        [ 30, 30, 30, 30 ]
                    ]
                }
            }
        },
        watch: {
            'props': function (n, o) {
                if (n.userId !== o.userId) this.loadUser();
            }
        },
        mounted: function() {
            this.loadUser();
        }
    }
</script>
<style>
    button {
        font-size: 13px !important
    }
</style>
